<mat-divider></mat-divider>
<footer>
    &copy; Todos los derechos reservados {{ currentYear }}
</footer>
